import{lazy as r}from"react";const o=r((()=>import("./LiveQueryProvider.js")));function t(r){return o}export{o as LiveQueryProvider,t as createLiveQueryProvider};
//# sourceMappingURL=index.js.map
